<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import ResponsiveImagePartial from '$components/common/partials/ResponsiveImagePartial/ResponsiveImagePartial.svelte';

  const video: any = $$props.video ? [$$props.video] : undefined;
  const animation: any = $$props.animation ? [$$props.animation] : undefined;
</script>

{#if $$props.hasImage}
  {#if $$props.imageConfigs}
    <!-- Add screenshot section slideshow interactivity functionality -->
    <!-- https://jira.sqprod.co/browse/XMSFE-267 -->
    <div data-hero-slideshow {...$$props.slideshowData}>
      {#each $$props.imageConfigs as imageConfig}
        <div class="heroSlide">
          <ResponsiveImagePartial config={imageConfig} />
        </div>
      {/each}
    </div>
  {:else}
    {#if $$props.aproposImage}
      <DynamicChildrenComponent children={$$props.aproposImage} />
    {/if}
    {#if $$props.imageConfig}
      <ResponsiveImagePartial config={$$props.imageConfig} />
    {/if}
  {/if}
{/if}
{#if $$props.hasMedia}
  <DynamicChildrenComponent children={video || animation} />
{/if}

<style lang="scss">
  @layer standard-components {
    .heroSlide {
      position: absolute;
      overflow: hidden;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 1;
      transform: none;

      &:first-of-type {
        position: relative;

        .no-js & {
          opacity: 1;
        }
      }

      .show-time & {
        transition:
          transform var(--duration-enter),
          opacity var(--duration-enter);
      }

      transition-timing-function: linear;

      [data-hero-slideshow][data-count='1'] & {
        transition-timing-function: var(--easing-decelerate);
      }
    }
  }
</style>
